<template>
  <div>
    <b-overlay :show="loading">

      <div>

        <div class="row no-margin pt-5">
            <div class="ibox col-md-12 payrun-wizard-breadcrumb mt-2">
                <div class="ibox-title dashboard_title px-0 py-4"><h4 class="atlhr-dashboard-title pt-0 my-2">Overtime Wizard<span><a v-bind:href="$api_url+'/company/dashboard'">Dashboard </a>/ Leave & Attendance / Overtime </span></h4></div>
            </div>
        </div>

        <div class="col-md-12 bg-white shadow-lg payrun-wizard-container ibox pb-5">

          <form-wizard ref="wizard" color="#0060C9" @on-complete="onComplete">
            <template slot="step" slot-scope="props">
                <wizard-step :tab="props.tab"
                :transition="props.transition"
                :key="props.tab.title"
                :index="props.index">
                </wizard-step>
            </template>
            <h2 class="py-2 mt-3 mb-4" slot="title">Process Flow</h2>

            <!-- Step 1 -->
            <tab-content title="Select Month and Fiscal Year" :before-change="changeMessageflagBefore">

                <div class="clearfix row form-btn-container rounded mb-4">
                    <div class="col-md-4 pl-0"><b-button class="custom-wizard-btn" :href="$api_url+'/leave-attendance/overtime/'"><b-icon icon="chevron-left" rotate="0" class="mr-2" scale="1"></b-icon> Back to Overtime Runs</b-button></div>
                    <div class="col-md-4 text-center custom-wizard-title">Select Month and Fiscal Year</div>
                    <div class="col-md-4 pr-0 text-right"><b-button type="button" variant="primary" @click="nextWizardStep()" :disabled="isFutureMonth">Next <b-icon icon="chevron-right" rotate="0" class="mt-n1" scale="1"></b-icon></b-button></div>
                </div>
                <h3 class="my-5 text-center d-inline-block w-100">Please choose your desired period</h3>

                <div class="row no-margin justify-content-center">
                    <div class="col-md-4 float-left px-3">
                        <div class="form-group">
                            <label for="name" class="col-form-label">Month</label>
                            <b-form-select
                                @change="validateDate"
                                v-model="month"
                                :options="$month_options ? $month_options : monthOptions"
                                name="selected_month"
                            ></b-form-select>
                        </div>
                    </div>
                    <div class="col-md-4 float-left px-3">
                        <div class="form-group">
                            <label for="name" class="col-form-label">Year</label>
                            <b-form-select
                                @change="validateDate"
                                v-model="year"
                                :options="$year_options ? $year_options : yearOptions"
                                name="selected_year"
                            ></b-form-select>
                        </div>
                    </div>
                </div>
            </tab-content>

            <!-- Step 2 -->
            <tab-content title="Select Date Range" :before-change="beforeChangeStep3">

                <div class="clearfix row form-btn-container rounded mb-4">
                    <div class="col-md-4 pl-0"><b-button class="custom-wizard-btn" type="button" variant="primary" @click="moveBack()"><b-icon icon="chevron-left" rotate="0" class="mt-n1" scale="1"></b-icon> Back</b-button></div>
                    <div class="col-md-4 text-center custom-wizard-title">Date Range</div>
                    <div class="col-md-4 pr-0 text-right"><b-button type="button" variant="primary" @click="generateOvertime" :disabled="loading || (date_range_mode != '' && (range_from_date == '' || range_to_date == ''))">Generate Overtime <b-icon icon="chevron-right" rotate="0" class="mt-n1" scale="1"></b-icon></b-button></div>
                </div>

                <div class="card border-0 no-shadow">
                    <div class="card-body py-0">
                        <div class="deprtment-top-block">
                            <h5 class="my-5 text-center d-inline-block w-100">Select a Date Range</h5>
                        </div>
                    </div>
                </div>

              <div v-if="date_range_mode == ''" class="d-flex flex-row justify-content-center align-items-center">
                <b-button @click="date_range_mode = 'include'" class="mr-2">Yes</b-button>
                <b-button @click="generateOvertime" class="ml-2">No, Generate Overtime</b-button>
              </div>

              <div v-else>
                <b-row class="d-flex justify-content-center align-items-center">
                  <b-col cols="12" md="8" lg="6">
                    <b-form-row v-if="date_range_mode != ''" class="justify-content-center mb-3">
                      <b-col cols="6">
                        <b-form-group id="range_from_date-group" label="From Date" label-for="range_from_date" class="required-field">
                          <b-input-group>
                            <b-form-input id="range_from_date" name="range_from_date" v-model="range_from_date" v-validate="'required|date_format:yyyy-MM-dd'" type="text"
                                          placeholder="YYYY-MM-DD" autocomplete="off" :state="validateState('range_from_date')" aria-describedby="range_from_date-feedback"
                                          data-vv-as="From Date"/>
                            <b-input-group-append>
                              <b-form-datepicker :min="minDate" :max="maxDate" id="range_from_date_picker" button-only right locale="en-US" v-model="range_from_date" @input="range_to_date = range_from_date"/>
                            </b-input-group-append>
                            <b-form-invalid-feedback id="range_from_date-feedback">{{ veeErrors.first('range_from_date') }}</b-form-invalid-feedback>
                          </b-input-group>
                        </b-form-group>
                      </b-col>

                      <b-col cols="6">
                        <b-form-group id="range_to_date-group" label="To Date" label-for="range_to_date" class="required-field">
                          <b-input-group>
                            <b-form-input id="range_to_date" name="range_to_date" v-model="range_to_date" v-validate="'required|date_format:yyyy-MM-dd'" type="text"
                                          placeholder="YYYY-MM-DD" autocomplete="off" :state="validateState('range_to_date')" aria-describedby="range_to_date-feedback"
                                          data-vv-as="To Date"/>
                            <b-input-group-append>
                              <b-form-datepicker :min="minDate" :max="maxDate" id="range_to_date_picker" button-only right locale="en-US" v-model="range_to_date"/>
                            </b-input-group-append>
                            <b-form-invalid-feedback id="range_to_date-feedback">
                              {{ veeErrors.first('range_to_date') }}
                            </b-form-invalid-feedback>
                          </b-input-group>
                        </b-form-group>
                      </b-col>
                    </b-form-row>
                  </b-col>
                </b-row>

                <b-row>
                  <b-col cols="12" class="text-center">
                    <b-button @click="date_range_mode=''; ">Cancel</b-button>
                    <b-button @click="generateOvertime" :disabled="loading || (date_range_mode != '' && (range_from_date == '' || range_to_date == ''))">
                      Generate Overtime
                    </b-button>
                  </b-col>
                </b-row>
              </div>
            </tab-content>

            <!-- Step 3 -->
            <tab-content title="Summary" :before-change="changeMessageflagBefore">

                <div class="clearfix row form-btn-container rounded mb-4">
                    <div class="col-md-4 pl-0"><b-button class="custom-wizard-btn" :href="$api_url+'/leave-attendance/overtime/'"><b-icon icon="chevron-left" rotate="0" class="mr-2" scale="1"></b-icon> Back to Overtime Runs</b-button></div>
                    <div class="col-md-4 text-center custom-wizard-title">Summary</div>
                </div>

              <div class="bg-wash mb-3 px-3 py-4">
                <b-row class="text-center">
                  <b-col>
                    <div class="text-muted small">Total Employees</div>
                    <div class="h4 font-weight-bold">{{ overtimesAggregate.employees }}</div>
                  </b-col>

                  <b-col>
                    <div class="text-muted small">Total Overtime Entries</div>
                    <div class="h4 font-weight-bold">{{ overtimesAggregate.entries }}</div>
                  </b-col>

                  <b-col>
                    <div class="text-muted small">Salary Benefit Days</div>
                    <div class="h4 font-weight-bold text-primary">{{ overtimesAggregate.salary_days }}</div>
                  </b-col>

                  <b-col>
                    <div class="text-muted small">Draft</div>
                    <div class="h4 font-weight-bold">{{ overtimesAggregate.draft }}</div>
                  </b-col>
                </b-row>
              </div>

              <div class="table-responsive employee-table-wrapper mt-3">
                <table class="employee-list-table table table-hover dataTable table-overflow table-sticky">
                  <thead class="table-head">
                  <tr>
                    <th>Employee Code</th>
                    <th>Employee Name</th>
                    <th>From</th>
                    <th>To</th>
                    <th>Worked on Holidays</th>
                    <th>Worked on Off Days</th>
                    <th>Salary Benefit Days</th>
                    <th>Suggested Overtime</th>
                    <th>Salary Type</th>
                    <th>Actions</th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr v-for="(row, index) in overtimes" :key="row.id" class="hover-bg table-row border-bottom mx-2">
                    <td>{{ row.employee_code }}</td>
                    <td>{{ row.name }}</td>
                    <td>{{ row.attendance_from }}</td>
                    <td>{{ row.attendance_to }}</td>
                    <td>{{ row.holiday_work_days }}</td>
                    <td>{{ row.offday_work_days }}</td>
                    <td>{{ row.salary_days }}</td>
                    <td>{{ row.p_overtime }}</td>
                    <td>{{ row.salary_type }}</td>
                    <td class="text-right">
                      <div class="action">
                        <b-button-toolbar class="float-right position-relative">
                          <a id="actionDropdown" class="dropdown-toggle clearfix action-dropdown-toggle" href="#" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"><b-icon icon="three-dots-vertical"></b-icon></a>
                          <div class="dropdown-menu action-dropdown-menu" aria-labelledby="actionDropdown">
                            <b-button-group class="">
                              <b-button class="border-0 rounded py-0" variant="outline-secondary" title="Edit Shift" @click="viewOvertime(row)">
                                <b-icon icon="pencil-fill" aria-hidden="true"></b-icon> Preview
                              </b-button>
                            </b-button-group>
                          </div>
                        </b-button-toolbar>
                      </div>
                    </td>
                  </tr>
                  <tr v-if="overtimes.length == 0">
                    <td colspan="11" class="text-center text-muted py-3">No overtime records for this period.</td>
                  </tr>
                  </tbody>
                </table>
              </div>
            </tab-content>
          </form-wizard>
        </div>
    </div>

      <b-modal id="overtime-details-modal" hide-footer size="xxl" centered>
        <template #modal-title>
          <div class="mb-3">
            <h5 class="mb-1">Overtime Details</h5>
            <p class="text-muted mb-0">
              Review Overtime records before the approval step.
            </p>
          </div>
        </template>

        <roster-overtime-details :can_edit="false" :row="selectedOvertimeRow" @reloadData="previewReport"></roster-overtime-details>
      </b-modal>

      <b-modal id="overtime-run-modal" hide-header hide-footer centered>
        <p class="my-4 pb-4">Do you want to generate new overtime report for individual employees or use the existing generation?</p>
        <b-row>
          <b-col cols="6" md="6" class="d-flex flex-row align-items-end flex-wrap mb-2">
            <b-button @click="goBackFromRunModal" class="mb-2 w-100" variant="primary" :disabled="loading">Go Back</b-button>
          </b-col>

          <b-col cols="6" md="6" class="d-flex flex-row align-items-end flex-wrap mb-2">
            <b-button @click="runOvertimeSettle" class="mb-2 w-100" variant="primary" :disabled="loading">Run Overtime</b-button>
          </b-col>
        </b-row>
      </b-modal>
    </b-overlay>
  </div>
</template>

<script>
import moment from "moment";
import { FormWizard, TabContent, WizardStep } from "vue-form-wizard";
import "vue-form-wizard/dist/vue-form-wizard.min.css";

export default {
  components: { FormWizard, TabContent, WizardStep },

  data() {
    return {
      payrun_date: '',
      daytypes: ["Hourly", "Off Day", "Holiday"],
      loading: false,
      overtimes: [],
      overtimeDetails: [],
      selectedOvertimeId: null,
      selectedOvertimeRow: null,
      settledSummary: {
        salary_days: 0,
        salary_type_label: "-",
      },
      minDate: '',
      maxDate: '',
      currentStep: 0,
      maxUnlockedStep: 1,
      emptytext: "No records found.",
      employee: {
        name: "",
        employee_code: "",
        pic: "",
        company_id: null,
      },
      year: new Date().getFullYear(),
      month: String(new Date().getMonth() + 1).padStart(2, "0"),
      monthOptions: [
        { value: 1, text: "January" },
        { value: 2, text: "February" },
        { value: 3, text: "March" },
        { value: 4, text: "April" },
        { value: 5, text: "May" },
        { value: 6, text: "June" },
        { value: 7, text: "July" },
        { value: 8, text: "August" },
        { value: 9, text: "September" },
        { value: 10, text: "October" },
        { value: 11, text: "November" },
        { value: 12, text: "December" }
      ],
      yearOptions: [],
      date_range_mode: "",
      dateRangeModeOptions: [
        { text: "Include Date Range", value: "include" },
        { text: "Exclude Date Range", value: "exclude" }
      ],
      range_from_date: "",
      range_to_date: "",
      overtimeFields: [
        { key: "employee_code", label: "Employee Code" },
        { key: "name", label: "Employee Name" },
        { key: "attendance_from", label: "From" },
        { key: "attendance_to", label: "To" },
        { key: "salary_days", label: "Salary Benefit Days" },
        { key: "salary_minutes", label: "Salary Minutes" },
        { key: "salary_type_label", label: "Salary Type" },
        { key: "status", label: "Status" }
      ],
    };
  },

  computed: {
    overtimesAggregate() {
      const rows = this.overtimes || [];
      let salary = 0;
      let draft = 0;
      const employeeSet = new Set();

      rows.forEach(r => {
        salary += Number(r.salary_days) || 0;
        if (Number(r.status) == 1 && Number(r.leave_settled) != 1) draft++;
        if (r.employee_id != null) employeeSet.add(r.employee_id);
      });

      return {
        employees: employeeSet.size,
        entries: rows.length,
        salary_days: salary.toFixed(2),
        draft: draft,
      };
    },

    isFutureMonth() {
      const today = new Date();
      const cy = today.getFullYear();
      const cm = today.getMonth() + 1;
      const y = Number(this.year);
      const m = Number(this.month);

      if (!y || !m) return false;
      if (y > cy) return true;
      if (y === cy && m > cm) return true;

      return false;
    },
  },

  methods: {
    moveBack: function () {
      this.$refs.wizard.prevTab();
    },

    changeMessageflagBefore: function () {
      let nav_wrapper = document.querySelector('.wizard-nav-pills');
      if (nav_wrapper) {
        let nav_active = nav_wrapper.querySelector('li.active');
        let wizard_icon_circle = nav_active && nav_active.querySelector('.wizard-icon-circle');
        if (wizard_icon_circle) {
          wizard_icon_circle.classList.add('activated');
        }
      }
      this.show_final_message = '';
      this.success = '';
      return true;
    },

    formatDate(date) {
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');

      return `${year}-${month}-${day}`;
    },

    viewOvertime(row) {
      this.selectedOvertimeRow = row;
      let formData = new FormData();
      formData.append("employee_id", row.employee_id);

      axios.post(this.$api_url + "/employee/setemployee", formData).then(res => {
        this.$bvModal.show('overtime-details-modal')
      });
    },

    buildRequestFormData() {
      const formData = new FormData();
      formData.append("year", this.year);
      formData.append("month", this.month);
      formData.append("date_range_mode", this.date_range_mode);
      formData.append("range_from_date", this.range_from_date || "");
      formData.append("range_to_date", this.range_to_date || "");
      return formData;
    },

    resetStepsAfter(step) {
      if (step <= 1) {
        this.date_range_mode = "";
        this.range_from_date = "";
        this.range_to_date = "";
        this.overtimes = [];
        this.emptytext = "No records found.";
      }

      if (step <= 2) {
        this.overtimeDetails = [];
        this.selectedOvertimeId = null;
        this.selectedOvertimeRow = null;
        this.employee = {
          name: "",
          employee_code: "",
          pic: "",
          company_id: null
        };
        this.settledSummary = {
          salary_days: 0,
          salary_type_label: "-",
        };
      }

      this.maxUnlockedStep = Math.max(1, step);
    },

    onComplete() {
      this.$bvToast.toast("Overtime flow completed.", {
        variant: "success",
        title: "Done",
        solid: true
      });
    },

    buildYearOptions() {
      let currentYear = new Date().getFullYear();
      let startYear = currentYear - 5;
      let endYear = currentYear + 2;
      let arr = [];

      for (let i = startYear; i <= endYear; i++) {
        arr.push({
          value: i,
          text: String(i)
        });
      }

      this.yearOptions = arr;
    },

    getWizard() {
      return this.$refs.wizard;
    },

    async nextWizardStep() {
      let wizard = this.getWizard();

      if (!wizard) {
        return;
      }

      let currentIndex = wizard.activeTabIndex;
      let go = true;

      try {
        if (currentIndex === 0) {
          go = await this.beforeChangeStep1();
        } else if (currentIndex === 1) {
          go = await this.beforeChangeStep3();   // date range validation
        }

        if (!go) {
          return;
        }

        this.maxUnlockedStep = Math.max(this.maxUnlockedStep, currentIndex + 1);

        if (typeof wizard.nextTab === "function") {
          wizard.nextTab();
        }
      } catch (e) {
        this.serverError(e);
      }
    },

    goToWizardStep(index) {
      let wizard = this.getWizard();

      if (!wizard) {
        return;
      }

      if (typeof wizard.changeTab == "function") {
        let currentIndex = wizard.activeTabIndex;
        wizard.changeTab(currentIndex, index);
        return;
      }

      if (typeof wizard.navigateToTab == "function") {
        wizard.navigateToTab(index);
      }
    },

    async beforeChangeStep1() {
      try {
        this.loading = true;

        this.getCompanyLeaveSettings();
        const response = await axios.post(this.$api_url + "/leave-attendance/overtime-runs/check-approved", {
          month: this.month,
          year: this.year
        });
        this.loading = false;

        if (response.data.approved) {
          this.$bvToast.toast("An approved overtime run already exists for this month. You cannot create another one.", {
            title: "Error",
            variant: "danger",
            solid: true
          });
          return false;
        }

        return true;
      } catch (error) {
        this.loading = false;
        this.serverError(error);
        return false;
      }
    },

    beforeChangeStep3() {
      if (!this.date_range_mode) {
        return true;
      }

      if (!this.range_from_date || !this.range_to_date) {
        this.$bvToast.toast("Please select both from date and to date.", {
          title: "Warning",
          variant: "warning",
          solid: true
        });
        return false;
      }

      if (this.range_from_date > this.range_to_date) {
        this.$bvToast.toast("From date cannot be greater than to date.", {
          title: "Warning",
          variant: "warning",
          solid: true
        });
        return false;
      }

      return true;
    },

    async previewReport() {
      try {
        const formData = this.buildRequestFormData();
        this.loading = true;
        const response = await axios.post(
            this.$api_url + "/leave-attendance/overtime/preview",
            formData
        );

        this.overtimes = response.data || [];

        if (this.overtimes.length === 0) {
          this.emptytext = "No records found.";
          this.$bvToast.toast("Generate Overtime first to Preview Existing Report", {
            title: "No Existing Report",
            variant: "danger",
            solid: true
          });
          return;
        }
        this.$bvModal.hide('overtime-details-modal');

        this.emptytext = "";
      } catch (e) {
        this.serverError(e);
      } finally {
        this.loading = false;
      }
    },

    async generateOvertime() {
      if (!this.beforeChangeStep3()) {
        return;
      }

      try {
        const formData = this.buildRequestFormData();

        this.loading = true;

        this.$bvToast.toast("We are generating overtime report for selected month", {
          variant: "success",
          title: "Processing",
          solid: true
        });

        await axios.post(
            this.$api_url + "/leave-attendance/overtime/generate",
            formData
        );

        const previewResponse = await axios.post(
            this.$api_url + "/leave-attendance/overtime/preview",
            formData
        );

        this.overtimes = previewResponse.data || [];

        if (this.overtimes.length === 0) {
          this.emptytext = "No records found.";
        } else {
          this.emptytext = "";
        }

        this.changeMessageflagBefore();
        this.maxUnlockedStep = 2;
        this.goToWizardStep(2);
      } catch (e) {
        this.serverError(e);
      } finally {
        this.loading = false;
      }
    },

    goBackFromRunModal() {
      this.$bvModal.hide("overtime-run-modal");
      this.$bvModal.show("overtime-details-modal");
    },

    async runOvertimeSettle() {
      if (this.overtimeDetails.length == 0) return;

      try {
        const formData = new FormData();

        const dates = this.overtimeDetails.map(item => moment(item.date, "YYYY-MM-DD"));
        const from = moment.min(dates).format("YYYY-MM-DD");
        const to = moment.max(dates).format("YYYY-MM-DD");

        const idFinalMap = this.overtimeDetails.reduce((acc, item) => {
          acc[item.id] = Number(item.final || 0);
          return acc;
        }, {});

        const employee_id = this.overtimeDetails[0].employee_id;

        formData.append("from", from);
        formData.append("to", to);
        formData.append("status", 2);
        formData.append("employee_id", employee_id);
        formData.append("overtime_id", this.selectedOvertimeId);
        formData.append("overtime", JSON.stringify(idFinalMap));

        this.loading = true;

        await axios.post(this.$api_url + "/leave-attendance/overtime/update", formData);

        this.$bvModal.hide("overtime-run-modal");

        const reloadFormData = this.buildRequestFormData();

        const previewResponse = await axios.post(this.$api_url + "/leave-attendance/overtime/preview", reloadFormData);

        this.overtimes = previewResponse.data || [];

        const settledRow = this.overtimes.find(row => row.employee_id == employee_id);

        if (settledRow) {
          this.settledSummary = {
            salary_days: settledRow.salary_days || 0,
            salary_type_label: settledRow.salary_type || "-",
          };
        }

        this.$bvToast.toast("Overtime settled successfully.", {
          solid: true,
          title: "Success",
          variant: "success"
        });
      } catch (e) {
        this.serverError(e);
      } finally {
        this.loading = false;
      }
    },

    getCompanyLeaveSettings: function () {
      if (!this.checkNet()) return false;
      axios.get(this.$api_url + '/leave-attendance/company/leave/settings', {
        params: {
          month: this.month,
        }
      }).then(function (response) {

        if (response.data.length != 0) {
          this.minDate = response.data.range.ot[0];
          this.maxDate = response.data.range.ot[1];
        }

      }.bind(this));

    },

    validateDate() {
      if (this.isFutureMonth) {
        this.$bvToast.toast("Future month can't be accessed!", {
          title: "Warning",
          variant: "danger",
          solid: true
        });
      }
    },
  },

  created() {
    this.buildYearOptions();
  }
};
</script>
